import { useQuery } from 'react-query';
import KpiService from '../../services/kpiService';

const usePortfoliosQuery = ({ organizationId, enabled = true }) => {
  const queryKey = ['portfolioOverview', organizationId];

  return useQuery(
    queryKey,
    ({ signal } = {}) => {
      const portfolioService = new KpiService();
      const requestOptions = signal ? { signal } : undefined;
      return portfolioService.getPortfolio(organizationId, requestOptions);
    },
    {
      enabled: Boolean(organizationId?.length && enabled),
      initialData: [],
      // Without this, staleTime makes the empty initialData count as fresh and
      // the first fetch never fires; age it so only fetched data is fresh.
      initialDataUpdatedAt: 0,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      retry: false,
    },
  );
};

export default usePortfoliosQuery;
